import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DefineTenderOfferDeadlineDTO, SupplierDTO, ETenderSupplierDTO, ETendersAttachmentDTO, ETenderAttachmentType } from 'src/app/shared/models/e-tender.model';
import { ActivatedRoute } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { Languages } from 'src/app/shared/models/enums.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { AppConfig } from 'src/app/shared/services/app.config';

@Component({
  selector: 'app-define-tender-deadline',
  templateUrl: './define-tender-deadline.component.html',
  styles: []
})
export class DefineTenderDeadlineComponent implements OnInit {
  defineTenderDeadlineForm: FormGroup;
  model: DefineTenderOfferDeadlineDTO;
  private tenderRequestId = '';
  suppliersDropdownSettings = {};
  responseObj: ResponseObject;
  @Output() tenderRequestLoadedFlag: EventEmitter<boolean> = new EventEmitter();
  submitted = false;
  @ViewChild('defineTenderDeadline',{static: false}) defineTenderDeadline: ElementRef;
  showRequest = true;
  suppliersList: SupplierDTO[];
  invalidOfferDeadline = false;
  AttachmentProgress: number;
  DefineOfferDeadlineAttachment: ETendersAttachmentDTO[] = [];
  constructor(
    private translate: TranslateService,
    private fileService: fileService,
    private formBuilder: FormBuilder,
    private etenderSrv: EtenderService,
    private globalSrv: GlobalServices) {
    if (history.state.data && history.state.data.tenderId) {
      this.tenderRequestId = history.state.data.tenderId;
    } else {
      window.history.back();
    }
    this.suppliersDropdownSettings = {
      singleSelection: false,
      idField: 'UserId',
      textField: 'CompanyName',
      selectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true
    };
  }

  ngOnInit() {
    this.setFormMode();
  }
  // Form Mode
  setFormMode(): void {
    // Edit Mode / Display Mode
    if (this.tenderRequestId != null) {
      this.globalSrv.isLoaderEnabled = true;
      this.getTenderRequest();
    }
  }
  getTenderRequest(): void {
    this.etenderSrv.GetTenderOfferDeadlineById(this.tenderRequestId).subscribe(
      data => {
        this.responseObj = data;
        this.getTenderRequestCompleted();
      },
      () => console.log('Something went wrong!!')
    );
  }
  getTenderRequestCompleted(): void {
    if (this.responseObj.Success) {
      this.model = this.responseObj.Data as DefineTenderOfferDeadlineDTO;
      this.tenderRequestLoadedFlag.emit(true);

      if (this.model.OfferDeadline != null) {
        this.model.ODTime = new Date(this.model.OfferDeadline);
        this.model.OD = new Date(this.model.OfferDeadline);
      }
      this.suppliersList = this.model.ETenderSuppliers.map(function (e) {
        return e.Supplier;
      });

      this.buildForm();
      this.globalSrv.isLoaderEnabled = false;
      // Disable Loader
    } else {
      // Enable Error
    }
  }
  buildForm() {
    this.defineTenderDeadlineForm = this.formBuilder.group({
      Id: [this.model.Id],
      OD: [this.model.OD, [Validators.required]],
      ODTime: [this.model.ODTime, [Validators.required]],
      OfferDeadline: [''],
      ETenderSuppliers: [this.model.ETenderSuppliers.filter(e => e.IsSupplierInvolved == true)
        .map(function (e) { return e.Supplier; }), [Validators.required]],
      DefineOfferDeadlineComments: [''],
      DefineOfferDeadlineAttachment: ['']
    });
  }
  get ETenderAttachmentType() {
    return ETenderAttachmentType;
  }
  get Validate() {
    return this.defineTenderDeadlineForm.controls;
  }
  AddAttachmentFile(event, currFormControl, docName, attachmentType: ETenderAttachmentType, progressVariableName) {
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        alert(res);
        return false;
      });
    }

    if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe((res: string) => {
        alert(res);
        return false;
      });

    }

    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ETenderUploadsFolder);
    this.fileService.fileUploaderForAdmin(formData).subscribe(
      event => {

        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);

          // console.log(`File is ${percentDone}% uploaded.`);


          this[progressVariableName] = percentDone;
        } else if (event instanceof HttpResponse) {

          const jsonResponse = event.body.Data;
          const Url = jsonResponse.Url;
          const attachment = new ETendersAttachmentDTO();
          attachment.URL = Url;
          attachment.DocumentName = docName;
          attachment.AttachmentTypeId = attachmentType;

          this.DefineOfferDeadlineAttachment = this.DefineOfferDeadlineAttachment.filter(h => h.AttachmentType !== attachmentType);
          this.DefineOfferDeadlineAttachment.push(attachment);
        }
      }
    );

  }
  onSubmit = () => {
    this.submitted = true;
    if (this.defineTenderDeadlineForm.get('OD') != null && this.defineTenderDeadlineForm.get('OD').value) {
      const selectedDate = this.defineTenderDeadlineForm.get('OD').value
        .toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' });
      const selectedTime = this.defineTenderDeadlineForm.get('ODTime').value
        .toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
      const fullDate = selectedDate + ', ' + selectedTime;
      this.defineTenderDeadlineForm.controls.OfferDeadline.setValue(fullDate);
    }
    this.invalidOfferDeadline =
      new Date(this.model.ClarificationDurationEndDate) > new Date(this.defineTenderDeadlineForm.controls.OfferDeadline.value);
    if (this.defineTenderDeadlineForm.invalid || this.invalidOfferDeadline) {
      this.navigaeToFirstInvalid(this.defineTenderDeadline);
      return;
    }
    this.model = this.defineTenderDeadlineForm.getRawValue();
    this.model.ETendersAttachments = this.DefineOfferDeadlineAttachment;
    if (this.defineTenderDeadlineForm.get('ETenderSuppliers').value != null &&
      this.defineTenderDeadlineForm.get('ETenderSuppliers').value.length > 0) {
      this.model.ETenderSuppliers = this.defineTenderDeadlineForm.controls.ETenderSuppliers.value.map(function (currItem) {
        const supplier = {} as ETenderSupplierDTO;
        supplier.Supplier = currItem;
        return supplier;
      });
    }
    this.globalSrv.isLoaderEnabled = true;
    this.etenderSrv.UpdateTenderOfferDeadline(this.model).subscribe(
      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          this.defineTenderDeadlineForm.reset();
          this.showRequest = false;
          this.globalSrv.isLoaderEnabled = false;
        }
      });
  }
  navigaeToFirstInvalid(CurrentTabElementRef: ElementRef) {
    const invalidControls = CurrentTabElementRef.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidControls.length > 0) {
      for (let index = 0; index < invalidControls.length; index++) {
        const element = invalidControls[index];
        if (element.localName != 'div') {
          element.focus();
          return;
        }
      }
    }
  }
}
